// extracted by mini-css-extract-plugin
module.exports = {"sponsored":"SponsoredBadge_sponsored__SSPx3"};